import { css, jsx } from '@emotion/core';
import { Table as AntTable } from 'antd';
import React from 'react';

import { bp, colors } from '@/styles';

const table = css`
  .ant-table {
    @media ${bp.sm} {
      font-size: 1.6rem;
    }
    &-body {
      overflow-x: auto;
    }
    &-row {
      background-color: white;
      &--clickable {
        cursor: pointer;
      }
    }
    &-thead {
      > tr > th {
        vertical-align: top;
        font-weight: 700;
        color: ${colors.secondaryGray};
        padding-top: 32px;
        .ant-table-column-sorter .ant-table-column-sorter-inner {
          margin-top: -0.35em;
          .ant-table-column-sorter {
            &-up,
            &-down {
              font-size: 1.4rem !important;
              &.on {
                color: ${colors.secondaryGray};
              }
            }
            &-up {
              height: 0.35em;
            }
          }
        }
      }
    }
    table {
      border-radius: 2px;
      overflow: hidden;
      box-shadow: 0 6px 12px 0 rgba(35, 32, 32, 0.1);
    }
    tbody {
      overflow: auto;
      tr {
        vertical-align: top;
      }
    }
  }
`;

/** @param {import("antd/lib/table").TableProps} props */
const Table = props => <AntTable css={table} {...props} />;

export default Table;
